import {Component, OnInit, ElementRef, Input} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SharedService } from '../shared.service';
import { UniqueVisitorRequest } from './uniqueVisitorRequest';
import { DeviceInfoResponse } from './deviceInfoResponse';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { DataStorageService } from '../data-storage.service';
import { EkpayUser } from '../../user/ekpay_user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  subcription: Subscription;
  lan: string;
  user: EkpayUser;
  isReady: boolean;
  // deviceInfo: any = null;
  currentUrl: any;
  currentLat: string;
  currentLong: string;
  uniqueVisitor: UniqueVisitorRequest;
  deviceInfoRes: DeviceInfoResponse;
  isshow: boolean = false;
  subscription: Subscription;
  lang: string;
  interval: any;
  @Input() dedicatedBiller;
  constructor(public router: Router,
    private logger: NGXLogger,
    private translate: TranslateService,
    private deviceService: DeviceDetectorService,
    private activatedRoute: ActivatedRoute,

    private sharedService: SharedService, private dataStorageService: DataStorageService) {
    // router.events
    //   .filter(e => e instanceof NavigationEnd)
    //   .forEach(e => {
    //     console.log("dbsjdsjd..." + router.routerState.root);
    //
    //     console.log("dsjdhskjdhjsk...." + router.routerState.root.firstChild.url);
    //   });
  }

  menuToggle() {
    this.isshow = !this.isshow;
  }

  ngOnInit() {
    this.sharedService.refreshData();
    this.isReady = true;
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.logger.debug('data lang is header' + this.lang);

      this.currentUrl = this.router.url; /// this will give you current url
      this.translate.use(this.lang);
    })

    this.deviceInfoRes = this.deviceService.getDeviceInfo() as DeviceInfoResponse;
    this.uniqueVisitor = new UniqueVisitorRequest();
    this.uniqueVisitor.browser = this.deviceInfoRes.browser
    this.uniqueVisitor.device = this.deviceInfoRes.device;
    this.uniqueVisitor.operatingSystem = this.deviceInfoRes.os;
    this.uniqueVisitor.osVersion = this.deviceInfoRes.os_version;
    this.uniqueVisitor.userAgent = this.deviceInfoRes.userAgent;

    this.logger.debug("device info....." + JSON.stringify(this.deviceInfoRes));
    navigator.geolocation.getCurrentPosition((position) => {
      this.showPosition(position);
      this.uniqueVisitor.location = this.currentLat + ", " + this.currentLong;
      this.logger.debug("unique visitor...." + JSON.stringify(this.uniqueVisitor));
      this.sharedService.uniqueVisitor(this.uniqueVisitor).subscribe(data => {
        this.logger.debug("response..." + JSON.stringify(data));
      }), (err) => {
        this.logger.debug("error response.....");
      }
    });



  }


  showPosition(position) {
    this.currentLat = position.coords.latitude;
    this.currentLong = position.coords.longitude;
    this.logger.debug("this.current" + this.currentLat + "this.curentlong.." + this.currentLong);
  }

  onclick() {
    if (localStorage.getItem("lang") == "en") {
      // this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      // this.translate.use("en");
      localStorage.setItem("lang", "en");
    }
    this.dataStorageService.setLangData(localStorage.getItem("lang"));
  }

  hidePhoneMenu() {
    this.isshow = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts